import { API_URL } from './api';

/**
 * Bulk loader + cache for player profile countries keyed by steamid64.
 *
 * Mirrors ``utils/avatars.js``: components render flags optimistically and
 * re-render via {@link onCountriesLoaded} once a batch resolves, so any
 * steamid-keyed surface (scoreboards, leaderboards) can show flags with a
 * single shared request. Only steamids with a country set are returned by the
 * API; unset/unlinked ids stay absent from the cache (no flag rendered).
 */
export const countryCache = {};
let countriesFetched = new Set();
let countryListeners = [];

export const onCountriesLoaded = (callback) => {
  countryListeners.push(callback);
  return () => {
    countryListeners = countryListeners.filter((cb) => cb !== callback);
  };
};

const notifyCountryListeners = () => {
  countryListeners.forEach((cb) => cb());
};

export const fetchCountriesBulk = async (steamids) => {
  const newIds = steamids.filter(
    (id) => id && !countryCache[id] && !countriesFetched.has(String(id)),
  );
  if (newIds.length === 0) return countryCache;

  newIds.forEach((id) => countriesFetched.add(String(id)));

  try {
    const response = await fetch(`${API_URL}/api/countries?steamids=${newIds.join(',')}`);
    const data = await response.json();
    if (data.countries) {
      Object.assign(countryCache, data.countries);
      notifyCountryListeners();
    }
  } catch (e) {
    console.error('Failed to fetch countries:', e);
  }

  return countryCache;
};
